import {GUID} from "app/shared/models/GUID-interface";

export class TabsModeGUID implements GUID{
    // constructor(public readonly GUID: string, public tabsViewMode: boolean, public tabsDisplayMode: boolean, public hideChart: boolean, public isTabsVisible: boolean){
    constructor(public readonly GUID: string, public tabsViewMode: boolean, public tabsDisplayMode: boolean, public isTabsVisible: boolean){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/tabs-mode-GUID.ts